import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { Drawer, Box, Typography, alpha, Avatar, styled } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { ReactComponent as Close } from '../../../../../assets/images/close-circle.svg';
import { useDispatch, useSelector } from 'react-redux';
import useResponsive from 'src/components/hooks/useResponsive';
import {
  Container1,
  Text,
  NamegenderContainer,
  ProfileIcon,
  BorderWidth,
  TagsContainer,
  Texts,
  TagsData,
  Container2,
  InnerContainer,
  Tags,
  MainContainer,
  DrawerHeader,
  HeaderInner,
  HeaderText,
  DrawerFooter,
  EditButton,
} from './Styles';
import useAppointmentDetails from '../../UseAppointmentDetails';
import { ReactComponent as EditIcon } from '../../../../../assets/images/edit-2.svg'
import {
  getAppointmentByIdRequest,
  getPatientByIdRequest,
  getTagByPatientIdRequest,
  getAreaByPatientIdRequest,
  getPatientInfoByIdRequest,
} from 'src/modules/app/store/appActions';
import EditProfile from '../Forms/EditProfile';
import DialogBox from 'src/components/shared/Dialog/DialogBox';
const PatientInfo = ({ open, onClose }) => {
  const { isMobile, isTablet, isDesktop } = useResponsive();
  const [opens, setOpens] = useState(false);
  const handleOpen = () => setOpens(true);
  const handleClose = () => setOpens(false);
  const theme = useTheme();
  const dispatch = useDispatch();
  const patientData = useSelector((state) => state.app.patientById);
  const patientDetails = patientData?.payload?.data?.patient;
  const TagArray = useSelector((state) => state.app.TagByPatientId?.payload?.data?.[0]);
  const areaData = useSelector((state) => state.app.AreaByPatientId?.payload?.data);
  const patientInfoData = useSelector((state) => state.app.patientInfoById);
  const patientInfoDetails = patientInfoData?.payload?.data?.[0] || {};
  const { appointmentDetails, PatientId, user, clinicId, appointmentId } = useAppointmentDetails();
  useEffect(() => {
    if (PatientId) {
      dispatch(getPatientByIdRequest(PatientId));
      dispatch(getTagByPatientIdRequest(PatientId));
      dispatch(getAreaByPatientIdRequest(PatientId));
      dispatch(getPatientInfoByIdRequest(PatientId));
    }
    if (appointmentId) {
      dispatch(getAppointmentByIdRequest(appointmentId));
    }
  }, [PatientId, appointmentId, dispatch]);
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: isMobile || isTablet ? '330px' : '380px',
          height: isMobile || isTablet ? '100%' : '1080px',
          borderLeft: `1px solid ${theme.palette.primary.light1}`,
          justifyContent: 'space-between'

        },
      }}
    >
      <Box>


        <DrawerHeader>
          <HeaderInner>
            <HeaderText>Profile Info</HeaderText>

            <Close
              width={24}
              height={24}
              onClick={onClose}
              sx={{ color: theme.palette.gery.black }}
              style={{ cursor: 'pointer' }}
            />
          </HeaderInner>
        </DrawerHeader>
        <MainContainer>
          <Container1>
            <ProfileIcon>{patientDetails?.fullName?.charAt(0).toUpperCase() || 'N/A'}</ProfileIcon>
            <NamegenderContainer>
              <Text>{patientDetails?.fullName || 'N/A'}</Text>

              <Texts>
                {patientDetails?.gender
                  ? patientDetails.gender.charAt(0).toUpperCase() +
                  patientDetails.gender.slice(1).toLowerCase()
                  : 'N/A'}
              </Texts>
            </NamegenderContainer>
          </Container1>
        </MainContainer>
        <BorderWidth />
        <MainContainer>
          <TagsContainer>
            <Texts>Tags</Texts>
            <TagsData>
              {Array.isArray(TagArray?.tag) && TagArray.tag.length > 0 ? (
                TagArray.tag.map((tagLabel, index) => <Tags key={index} label={tagLabel} />)
              ) : (
                <Tags label="No tags available" />
              )}
            </TagsData>
          </TagsContainer>
        </MainContainer>
        <BorderWidth />
        <MainContainer>
          <Container2>
            <InnerContainer>
              <Texts>Age</Texts>
              <Text>{(function() {
                const ageStr = patientDetails?.detailedAge?.ageString;
                if (ageStr) return ageStr;
                if (patientDetails?.dateOfBirth) {
                  const birth = dayjs(patientDetails.dateOfBirth);
                  const now = dayjs();
                  const years = now.diff(birth, 'year');
                  const months = now.diff(birth.add(years, 'year'), 'month');
                  const days = now.diff(birth.add(years, 'year').add(months, 'month'), 'day');
                  return `${years} ${years === 1 ? 'Year' : 'Years'} ${months} ${months === 1 ? 'Month' : 'Months'} ${days} ${days === 1 ? 'Day' : 'Days'}`;
                }
                return patientDetails?.age ? `${patientDetails.age} ${patientDetails.age === 1 ? 'Year' : 'Years'}` : 'N/A';
              })()}</Text>
            </InnerContainer>
            <InnerContainer>
              <Texts>Location</Texts>
              <Text>{areaData?.[0]?.area || 'N/A'}</Text>
            </InnerContainer>
          </Container2>
        </MainContainer>
        <MainContainer>
          <Container2>
            <InnerContainer>
              <Texts>Weight</Texts>
              <Text>{patientInfoDetails?.weight ? `${patientInfoDetails.weight} kg` : 'N/A'}</Text>
            </InnerContainer>
            <InnerContainer>
              <Texts>Height</Texts>
              <Text>{patientInfoDetails?.height ? `${patientInfoDetails.height} cm` : 'N/A'}</Text>
            </InnerContainer>
          </Container2>
        </MainContainer>
        <BorderWidth />
        <MainContainer>
          <Container2>
            <InnerContainer>
              <Texts>Pulse Rate</Texts>
              <Text>{patientInfoDetails?.pulseRate ? `${patientInfoDetails.pulseRate} bpm` : 'N/A'}</Text>
            </InnerContainer>
            <InnerContainer>
              <Texts>SpO2</Texts>
              <Text>{patientInfoDetails?.spo2 ? `${patientInfoDetails.spo2}%` : 'N/A'}</Text>
            </InnerContainer>
          </Container2>
        </MainContainer>
        <BorderWidth />
        <MainContainer>
          <Container2>
            <InnerContainer>
              <Texts>Resp. Rate</Texts>
              <Text>{patientInfoDetails?.respiratoryRate ? `${patientInfoDetails.respiratoryRate} bpm` : 'N/A'}</Text>
            </InnerContainer>
            <InnerContainer>
              <Texts>Temperature</Texts>
              <Text>{patientInfoDetails?.temperature ? `${patientInfoDetails.temperature}°F` : 'N/A'}</Text>
            </InnerContainer>
          </Container2>
        </MainContainer>
        <BorderWidth />
      </Box>
      <DrawerFooter>
        <EditButton
          variant="outlined"
          startIcon={<EditIcon width="18px" height="18px" />}
          onClick={handleOpen}
        >Edit</EditButton>
      </DrawerFooter>
      <DialogBox open={opens}
        PaperProps={{
          sx: {
            // maxWidth: 'none',
            margin: '10px !important'
          }
        }}>
        <EditProfile onClose={handleClose} />
      </DialogBox>

    </Drawer>
  );
};
export default PatientInfo;
